import { Resource as p, API as h } from "@coveo/platform-client";
import { shouldMockBatchAnswer as r } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerDatasetListResponse as n, createMockBatchAnswerDataset as l } from "./BatchAnswerDatasets.mocks.js";
const o = 2e3, u = 10, i = class i extends p {
  listDataset(e, t) {
    return r(t == null ? void 0 : t.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(
          n(
            u,
            e.page,
            e.perPage
          )
        );
      }, o);
    }) : this.api.get(
      this.buildPath(i.baseUrl, e)
    );
  }
  getDataset(e, t) {
    return r(t == null ? void 0 : t.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(l());
      }, o);
    }) : this.api.get(
      `${i.baseUrl}/${e.datasetId}`
    );
  }
  createDataset(e, t) {
    return r(t == null ? void 0 : t.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s(l());
      }, o);
    }) : this.api.post(i.baseUrl, e);
  }
  deleteDataset(e, t) {
    return r(t == null ? void 0 : t.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s();
      }, o);
    }) : this.api.delete(`${i.baseUrl}/${e.datasetId}`);
  }
};
i.baseUrl = `/rest/organizations/${h.orgPlaceholder}/answer/v1/datasets`;
let d = i;
export {
  d as BatchAnswerDatasetsResource
};
//# sourceMappingURL=BatchAnswerDatasets.resource.js.map
